<template>
    <div class="d-flex align-items-center mt-1" v-if="isMulti"><i class="tim-icons text-danger icon-alert-circle-exc mr-2"></i> <p class="mb-0"> {{ message }} </p> </div>
</template>

<script>
const chars=[
			'a-z',
			'а-я',
			'\u0370-\u03ff', //греческий
			'\u0250-\u02af', // доп английский
			'\u1d00-\u1d7f', // расширенный английский
			// '\u10300-\u1032f', // этрусские буквы
			// '\u10330-\u1034f', // Готское письмо
			// '\u10400-\u1044f', // Дезеретское письмо
			// '\u104B0-\u104ff', // Осейдж
			
		];
		const charsR=chars.map(a=>new RegExp('['+a+']+','i'))
		// const charsReplace=chars.map((c,i)=>new RegExp('(['+c+'])(['+chars.slice(0,i).concat(chars.slice(i+1)).join('')+'])','i'));
		const r=new RegExp('[^0-9'+chars.join('')+']','i')
// console.log(r);
export default {
		name: 'ReCheckMultiLanguage',
		components: {

		},
		props: {
			value: {
				type: String,
				default: '',
			},
			message: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: 'Вы ввели символы из разных языков. Вы уверены, что не допустили ошибку?',
			},

		},
        computed:{
            isMulti(){
                return String(this.value)
                    .split(r)
                    .filter(w=>charsR.reduce((acc,r)=>acc+(w.match(r)?1:0),0)>1)
                    .length > 0
            }
        }
    }
</script>